/* globals Store */
import Vue from "vue";
import Vuex from "vuex";

import api from "@/utils/backend-api";
import {
  sendSuccessNotice,
  sendErrorNotice,
  closeNotice,
  getDefaultPagination,
  commitPagination,
} from "@/utils/store-util.js";

import { get } from "lodash";
import auth from '@/utils/auth'

const state = {
  items: [],
  pagination: {},
  // page: 0,
  // pages: 0,
  loading: false,
  mode: "",
  snackbar: false,
  notice: "",
  order: "",
};


const getters = {
};

const actions = {
  getAllOrders ({ commit }) {
    commit("setLoading", { loading: true });
    api.getData("OrderHistory.php?format=web").then(res => {
      const orders = res.data;
      commitPagination(commit, orders);
      commit("setLoading", { loading: false });
    })
    .catch(err => {
      console.log(err);
      Store.dispatch('user/logout')
      location.reload()
      // this.$router.push('/logout')
    });
  },
  searchOrders ({ commit }, data, pagination) {
    var searchQuery = data.searchQuery;
    var postData = data.postData.replace("\n", ",");
    searchQuery = searchQuery.replace("New", "1");
    searchQuery = searchQuery.replace("In Process", "2");
    searchQuery = searchQuery.replace("Rejected", "3");
    searchQuery = searchQuery.replace("Replied", "4");

    var imeis = {"imeilist": postData};

    api.postData("OrderHistory.php?format=web&" + searchQuery, imeis).then(res => {
      const orders = res.data;
      commitPagination(commit, orders);
    });
  },
  closeSnackBar ({ commit }, timeout ) {
     closeNotice(commit, timeout);
  }
};

const mutations = {
  setCustomers (state, customers) {
    state.customers = customers;
  },
  setCategories (state, categories) {
    state.categories = categories;
  },
  setProducts (state, products) {
    // console.log(products)
    state.products = products
  },
  setOrderProducts (state, products) {

    state.order.products = products;
  },
  setItems (state, orders) {
    state.items = orders;
  },
  setPagination (state, pagination) {
    state.pagination = pagination;
  },
  setLoading (state, { loading }) {
    state.loading = loading;
  },
  setNotice (state, { notice }) {
    // console.log(" notice .... ", notice);
    state.notice = notice;
  },
  setSnackbar (state, { snackbar }) {
    state.snackbar = snackbar;
  },
  setMode (state, { mode }) {
    state.mode = mode;
  },
  setOrder (state, {order}) {
    state.order = order
  },
  setLastOrder (state, {order}) {
    state.lastcreatedorder = order
  },
  setComments (state, {comments}) {
    state.comments = comments
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/orders.js